<template>
    <div class="loading text-center my-4">
        <div class="jumbotron">
            <div class="text-center">
                <i class="fa fa-spinner fa-pulse fa-3x text-primary"></i>
                <p class="lead mt-3">Cargando...</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'loading',
};
</script>
